// Neon's hosted-checkout success return carries only the claim token, not the campaign.
const CAMPAIGN_CODE_STORAGE_KEY = 'externalSalesCampaignCode';

export function persistCampaignCode(campaignCode: string): void {
  try {
    window.sessionStorage.setItem(CAMPAIGN_CODE_STORAGE_KEY, campaignCode);
  } catch {
    // Storage can throw (private mode, quota, disabled); the read side already treats a missing value as normal.
  }
}

export function readPersistedCampaignCode(): string | null {
  try {
    return window.sessionStorage.getItem(CAMPAIGN_CODE_STORAGE_KEY);
  } catch {
    return null;
  }
}
